import { apiBaseURL, toastifyType, ycrAssetType } from "../../../constant";
import { setLoading } from "../loadingAction";
import apiConfig from '../../../config/apiConfig';
import { addTost } from "../toastAction";

export const ycrAssetAction = (payload) => async (dispatch) => {
  try {
    // dispatch(setLoading(true));
    const response = await apiConfig.post(apiBaseURL.INTEREST_RATES_DATA_TYPES_ASSET, payload);
    dispatch({ type: ycrAssetType.FETCH_INTEREST_RATES_DATA_TYPES_ASSET, payload: response.data.data });
    dispatch(setLoading(false));
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }));
  }
};

// export const ycrAssetActionWithPagination = (filter, setTotalRecords, setTotalPages) => async (dispatch) => {
//   try {
//     // dispatch(setLoading(true));
//     const response = await apiConfig.post(apiBaseURL.INTEREST_RATES_DATA_TYPES_ASSET + `?country=${filter.country}&interestRateDataType=${filter.interestRateDataType}&page=${filter?.currentPage}&perPage=${filter?.perPage}`);
//     dispatch({ type: ycrAssetType.FETCH_INTEREST_RATES_DATA_TYPES_ASSET, payload: response.data.data });
//     setTotalRecords && setTotalRecords(response.data?.data?.totalRecords)
//     setTotalPages && setTotalPages(response.data?.data?.totalPage)
//     dispatch(setLoading(false));
//   } catch (error) {
//     dispatch(setLoading(false));
//     dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }));
//   }
// };